class ActionProvider {
  constructor(createChatBotMessage, setStateFunc, createClientMessage) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
    this.createClientMessage = createClientMessage;
  }
  // const [isTyping, setIsTyping] = useState(true);
  handleOptions = (options) => {
    const message = this.createChatBotMessage(
      "How can I help you? Below are some possible options.",
      {
        widget: "overview",
        loading: true,
        terminateLoading: true,
        ...options
      }
    );

    this.addMessageToState(message);
  };


  handleContact = () => {
    const message = this.createChatBotMessage(
      "Call +1 720-414-5030 for Intelle-Sphere Assistance.",
      {
        widget: "support",
        loading: true,
        terminateLoading: true,
        withAvatar: true
      }
    );

    this.addMessageToState(message);
  };


  handleProductOverview = () => {
    const message = this.createChatBotMessage(
      "Great choice! Here are our top programs designed to boost your career:",
      {
        widget: "ProductOverview",
        loading: true,
        terminateLoading: true,
        withAvatar: true
      }
    );

    this.addMessageToState(message);
  };

  handleFeatures = () => {
    const message = this.createChatBotMessage(
      "We partner with leading companies to place skilled professionals. Here are our top programs designed to boost your career:",
      {
        widget: "Features",
        loading: true,
        terminateLoading: true,
        withAvatar: true
      }
    );

    this.addMessageToState(message);
  };

  handleBookDemo = () => {
    const message = this.createChatBotMessage(
      "Awesome! 🚀 Let’s schedule your free career consultation. Please provide your contact details:",
      {
        widget: "Book a Demo",
        loading: true,
        terminateLoading: true,
        withAvatar: true
      }
    );

    this.addMessageToState(message);
  };
handleForSchools = () => {
  const message = this.createChatBotMessage(
    "We are a staffing & training company dedicated to shaping your career. ✔️ 500+ students trained ✔️ 200+ successful job placements ✔️ Partnerships with top IT companies",
    {
      widget: "ForSchool",
      loading: true,
      terminateLoading: true,
      withAvatar: true
    }
  );

  this.addMessageToState(message);
};
  handleDemoFormSubmit = (formData) => {
    const message = this.createChatBotMessage(
      `✅ Thanks, ${formData.name}! Our team will contact you at ${formData.email} soon to schedule your demo.`
    );
    this.addMessageToState(message);

    // 👉 Here you can also send `formData` to your backend API
    // console.log("Demo Request:", formData);
  };


  handleThanks = () => {
    const message = this.createChatBotMessage("You're welcome, and stay safe!");

    this.addMessageToState(message);
  };

  handleAttendance = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *Machine Learning with Python*: Our comprehensive program covers the latest in AI and ML, preparing you for top roles in the tech industry."
    );
    
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like book a consultation?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };

 
  handleExams = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *Cyber Security Fundamentals*: Our program covers the latest in cybersecurity, preparing you for top roles in the tech industry."
    );
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like book a consultation?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };

  handleFees = () => {
    const featureMessage = this.createChatBotMessage(
      "📌 *General IT / Software Roles*: Our program covers the latest in IT and software roles, preparing you for top roles in the tech industry."
    );
    const ctaMessage = this.createChatBotMessage(
      "👉 Would you like book a consultation?",
      {
        widget: "bookDemoOption",
        loading: true,
      terminateLoading: true,
      withAvatar: true // custom widget with button(s)
      }
    );
  
    this.addMessageToState(featureMessage);
    this.addMessageToState(ctaMessage);
  };





  addMessageToState = (message) => {
    this.setState((state) => ({
      ...state,
      messages: [...state.messages, message]
    }));
  };

  // addMessageToState = (message) => {
  //   // Show typing state
  //   console.log("🔄 Setting isTyping to TRUE");
  //   this.setState((state) => ({
  //     ...state,
  //     isTyping: true
  //   }));

  //   // Add message after delay
  //   setTimeout(() => {
  //     console.log("✅ Setting isTyping to FALSE and adding message");
  //     this.setState((state) => ({
  //       ...state,
  //       isTyping: false,
  //       messages: [...state.messages, message]
  //     }));
  //   }, 1200); // 1 second delay
  // };
}

export default ActionProvider;
